import { bearerFetcher, useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"
import { CleaningStatus } from "@/model/cleaningInfo"

interface ListActiveOperationsOutput {
    operations: Operation[]
}

export interface Operation {
    operationId: string
    cleaningStatus: CleaningStatus
    cleaningDate: string
    photoTourId?: string
    createdAt: number
    scheduleStart?: number | null
    scheduleEnd?: number | null
    deadlineAt?: number | null
}

export const useListActiveOperations = (token: string) => {
    const endpoint = m2mCleaning_cleanerV3.listActiveOperationsForCleaner

    return useAuthBearerFetch<ListActiveOperationsOutput>(
        token,
        // カスタムフェッチ内でurlが定義されいるので、このendpointは不要ではあるが、useSWRの仕組み上は必要なので残している
        endpoint(),
        {
            method: endpoint.method,
            fetch: () => loopFetch(token)
        }
    )
}

const composeUrlWithParams = (
    endpoint: string,
    params: { pageSize: number; page: number }
) => {
    return endpoint + `?pageSize=${params.pageSize}&page=${params.page}`
}

const defaultPageSize = 100

const loopFetch = async (
    token: string,
    option: {
        pageSize: number
    } = {
        pageSize: defaultPageSize
    }
) => {
    const endpoint = m2mCleaning_cleanerV3.listActiveOperationsForCleaner

    const ret: ListActiveOperationsOutput = { operations: [] }
    let currentPage = 1

    while (true) {
        const { data, error } = await bearerFetcher<ListActiveOperationsOutput>(
            token,
            composeUrlWithParams(endpoint(), {
                pageSize: option.pageSize,
                page: currentPage
            })
        )
        if (error) throw error

        const operation = data?.operations ?? []

        // 次のページが空であれば終了
        if (operation.length === 0) break

        currentPage++
        ret.operations.push(...operation)
    }

    return ret
}
